// @ts-ignore
import * as dynamic from './dynamic/i18n.tr';
import { ITranslations } from './types';

const i18n: ITranslations = {};
i18n['agencies'] = {};
i18n['agencies']['budget-asc-order'] = "";
i18n['agencies']['budget-desc-order'] = "";
i18n['agencies']['budget-from'] = "";
i18n['agencies']['budget-to'] = "";
i18n['agencies']['budgets'] = "";
i18n['agencies']['certificates'] = "Servis";
i18n['agencies']['cities'] = "Şehir";
i18n['agencies']['city'] = "Şehir";
i18n['agencies']['countries'] = "Ülke";
i18n['agencies']['country'] = "Ülke";
i18n['agencies']['currency'] = "";
i18n['agencies']['filter-all-cities-name'] = "Tüm şehirler";
i18n['agencies']['filter-all-cities-name-prepositional'] = "şehirlerde";
i18n['agencies']['filter-all-cities-preposition'] = "tüm";
i18n['agencies']["filter-all-certs-name"] = "Tümü";
i18n['agencies']["filter-all-certs-name-prepositional"] = "Tümü";
i18n['agencies']["filter-all-certs-preposition"] = "";
i18n['agencies']['filters-conjunction'] = " ve ";
i18n['agencies']['filters-delimiter'] = "";
i18n['agencies']['filters-reset'] = "Filtreleri sıfırla";
i18n['agencies']['not-found'] = "Bu koşullara uygun şirketler bulunamadı. Lütfen, filtreleri sıfırlayıp tekrar arama yapmayı deneyin.";
i18n['agencies']['only-offices-found'] = "Diğer şehirlerde sertifikalı ajansların şubeleri belirtilen koşullara uygun görünüyor.";
i18n['agencies']['only-partners-found'] = " Aktif sertifikaları olmayan ajansların şubeleri belirtilen koşullara uygun görünüyor. ";
i18n['agencies']['other-offices'] = "Diğer şehirlerde sertifikalı ajansların şubeleri";
i18n['agencies']['other-partners'] = "Aktif sertifikası olmayan ajanslar";
i18n['agencies']['region-choose'] = "Ülke seçin";
i18n['agencies']['search'] = "Arama";
i18n['agencies']['service'] = "Servis";
i18n['agencies']['show-text'] = "";
i18n['agencies']['specify'] = "Aramayı netleştir";
i18n['agencies']['text'] = "Bu sayfada bölgenize ait reklam ajansları sıralanmıştır. Başka arama bölgesi aşağıdaki filtre yardımıyla seçilebilir. Rusya'da, Ukrayna'da ve Beyaz Rusya'da Yandex'in sertifikalı ajansları bulabilirsiniz.";
i18n['agencies']['title'] = "Sertifikalı ajanslar";
i18n['dashboard'] = {};
i18n['dashboard']['cat.1239063375'] = "Elektronik eşya";
i18n['dashboard']['cat.1412163005'] = "Otomotiv: Hizmetler";
i18n['dashboard']['cat.1473509328'] = "Eğitim ve istihdam";
i18n['dashboard']['cat.1582506554'] = "Giyim ve ayakkabı";
i18n['dashboard']['cat.1644710081'] = "Ev ve bahçe gereçleri";
i18n['dashboard']['cat.200304283'] = "Otomotiv: Ürünler";
i18n['dashboard']['cat.2107020788'] = "Diğer";
i18n['dashboard']['cat.2222683737'] = "İlaç";
i18n['dashboard']['cat.2408536966'] = "Ev hizmetleri ve yemek dağıtımı";
i18n['dashboard']['cat.2455984605'] = "UNKNOWN";
i18n['dashboard']['cat.2473087795'] = "Hukuk ve danışmanlık";
i18n['dashboard']['cat.2587886448'] = "İnşaat ve tadilat: Ürünler";
i18n['dashboard']['cat.3119845291'] = "Hediyelik eşya";
i18n['dashboard']['cat.3315302486'] = "İnşaat ve tadilat: Hizmetler";
i18n['dashboard']['cat.3566538395'] = "FMCG";
i18n['dashboard']['cat.3737414780'] = "Beyaz eşya";
i18n['dashboard']['cat.3989916053'] = "Emlak";
i18n['dashboard']['cat.4170831985'] = "Turizm ve seyahat";
i18n['dashboard']['cat.4194169969'] = "B2B ";
i18n['dashboard']['cat.491274388'] = "Eğlence ve medya";
i18n['dashboard']['cat.518209040'] = "Spor ürünleri ve hizmetleri";
i18n['dashboard']['cat.570002290'] = "FOR_TOTAL_COUNTER";
i18n['dashboard']['cat.676268400'] = "IT ve telekomünikasyon";
i18n['dashboard']['cat.80967844'] = "Finans ve sigorta";
i18n['dashboard']['cat.auto'] = "Oto";
i18n['dashboard']['cat.consulting'] = "Danışmanlık";
i18n['dashboard']['cat.finance'] = "Finans ";
i18n['dashboard']['cat.realty'] = "Emlak ";
i18n['dashboard']['cat.retail'] = "Perakende";
i18n['dashboard']['comparison.add'] = "Karşılaştırmaya ekle";
i18n['dashboard']['comparison.delete'] = "Karşılaştırmayı kaldır";
i18n['dashboard']['error.modal'] = "Seçilen parametrelere göre veriler geçersiz veya işlenme aşamasıdadır";
i18n['dashboard']['error.widget'] = "Veriler gösterilemedi, daha sonra deneyin.";
i18n['dashboard']['platform.desktop'] = "Masaüstü/Dizüstü bilgisayarlar";
i18n['dashboard']['platform.mobile'] = "Mobil";
i18n['dashboard']['region.1'] = "Moskova ve Moskova oblastı";
i18n['dashboard']['region.10174'] = "Saint-Petersburg ve Leningradskaya oblastı";
i18n['dashboard']['region.102444'] = "Kuzey Kafkasya FB";
i18n['dashboard']['region.17'] = "Severo-Zapadniy FB (St. Petersburg ve Leningradskaya Oblast hariç)";
i18n['dashboard']['region.17,-2'] = "Severo-Zapadniy FB";
i18n['dashboard']['region.225'] = "Rusya";
i18n['dashboard']['region.26'] = "Yuzhniy FB";
i18n['dashboard']['region.3'] = "Merkez FB (Moskova ve Moskovskaya Oblast hariç)";
i18n['dashboard']['region.3,-213'] = "Merkez FB";
i18n['dashboard']['region.40'] = "Privolzhskiy FB";
i18n['dashboard']['region.52'] = "Uralskiy FB";
i18n['dashboard']['region.59'] = "Sibirya FB";
i18n['dashboard']['region.73'] = "Dalnevostochniy FB";
i18n['dashboard']['title.add'] = "Karşılaştırmayı ekle";
i18n['dashboard']['title.remove'] = "Karşılaştırmayı kaldır";
i18n['dashboard']['type.interest'] = "İlginin değişimi, haftalık";
i18n['dashboard']['type.network'] = "YRA. CPC değişimi, haftalık";
i18n['dashboard']['type.search'] = "Arama. CPC değişimi, haftalık";
i18n['dashboard']['widget.type.interest'] = "ilginin değişim hızı";
i18n['offices'] = {};
i18n['offices']['readmore'] = "Ayrıntılı bilgi";
i18n['news'] = {};
i18n['news']['400_CII'] = "Neden: Böyle bir yorum mevcut değil";
i18n['news']['400_LII'] = "Neden: Bir hata oluştu. Lütfen sayfayı yenileyip tekrar deneyin";
i18n['news']['400_SII'] = "Neden: Sayfa adresi geçersiz simgeler içeriyor. Lütfen adresi kontrol edin ve sayfayı yenileyip tekrar deneyin";
i18n['news']['400_VFL'] = "Neden: Bazı alanlar boş bırakılmış veya geçersiz değerler içeriyor. Lütfen hatayı düzeltip tekrar deneyin";
i18n['news']['401_NAU'] = "Neden: Kullanıcı girişi yapmadınız. Lütfen kullanıcı adınızla giriş yapıp tekrar deneyin";
i18n['news']['403_CCI'] = "girilen kod yanlış";
i18n['news']['403_PRO'] = "Neden: Yorum gönderme işlevi yazıyı gönderen kullanıcı tarafından devre dışı bırakıldı";
i18n['news']['403_UAC'] = "Neden: Şikayetiniz daha önce gönderildi. Sadece bir kere şikayet gönderebilirsiniz.";
i18n['news']['403_UBN'] = "Neden: Erişim yetkiniz moderasyon tarafından iptal edildi";
i18n['news']['403_UNM'] = "Neden: Bir erişim yetkisi hatası oluştu. Lütfen sayfayı yenileyip tekrar deneyin";
i18n['news']['413_ETL'] = "Neden: Metninizin uzunluğu 12 bin karakterin üzerinde";
i18n['news']['500_ISE'] = "Neden: Bir hata oluştu. Lütfen daha sonra tekrar deneyin";
i18n['news']['breadcrumb'] = "Ana haberler";
i18n['news']['comments'] = "Yorumlar";
i18n['news']['comments.add_error'] = function(params) { return "Yorum gönderilemedi. " + params["reason"] };
i18n['news']['comments.banned'] = "";
i18n['news']['comments.bound-phone'] = "";
i18n['news']['comments.bound-phone-text'] = "";
i18n['news']['comments.complain_error'] = function(params) { return "Yorum şikayeti gönderilemedi. " + params["reason"] };
i18n['news']['comments.count'] = function(params) { return params["count"] + " " + dynamic.plural_adv({"count": "         " + params["count"] + "     ", "one": "yorum", "some": "yorum", "many": "yorum", "none": "yorum"}) };
i18n['news']['comments.enter-url'] = "Adres yazın";
i18n['news']['comments.get_error'] = function(params) { return "Yorumlar alınamadı, " + params["reason"] + "." };
i18n['news']['comments.hint'] = "Yazı tipini düzenlemek veya bağlantı eklemek için ilgili kısa metni seçin.";
i18n['news']['comments.load-captcha_error'] = function(params) { return "Güvenlik görseli alınamadı: " + params["reason"] + "." };
i18n['news']['comments.non-authorized'] = "Yorum yazmak için kullanıcı girişi yapın";
i18n['news']['comments.removed'] = "";
i18n['news']['comments.send'] = "Gönder";
i18n['news']['comments.unavailable'] = "";
i18n['news']['comments.your-reply'] = "Yanıtınız";
i18n['news']['comments.your-word'] = "Söz sizde";
i18n['news']['complaint'] = "Şikayet et";
i18n['news']['complaint.question'] = "Yorumu şikayet etmek ister misiniz?";
i18n['news']['default_error'] = "Bir hata oluştu. Lütfen daha sonra tekrar deneyin";
i18n['news']['edu.nav.list'] = "Ders listesine dön";
i18n['news']['edu.nav.next'] = "Sonraki derse git";
i18n['news']['filters.clear'] = "Filtreleri sıfırla";
i18n['news']['for_all_time'] = "Tüm zamanlar için";
i18n['news']['index.archive'] = "Haber arşivi";
i18n['news']['index.title'] = "Reklam teknolojileri haberleri";
i18n['news']['related.title'] = "Konuyla ilgili diğer içerik:";
i18n['news']['reply'] = "Yanıtla";
i18n['news']['tags'] = "Tüm konular";
i18n['edu'] = {};
i18n['edu']['answer'] = "Cevapla";
i18n['edu']['city'] = "Şehir";
i18n['edu']['company'] = "Şirket";
i18n['edu']['contact'] = "İrtibat kur";
i18n['edu']['country'] = "Ülke";
i18n['edu']['events'] = "Etkinlikler";
i18n['edu']['expert.readyToComeInYourCity'] = "Şehrinize seyahat etmeye hazırım";
i18n['edu']['expert.readyToTrips'] = "İş seyahatlerine hazırım";
i18n['edu']['leave.feedback'] = "Yorum yaz";
i18n['edu']['lesson-content'] = "Bu dersin konuları";
i18n['edu']['lessons.list'] = "Ders listesi";
i18n['edu']['months'] = "Ay";
i18n['edu']['next.lesson'] = "Sonraki ders";
i18n['edu']['online'] = "Çevrimiçi";
i18n['edu']['prev.lesson'] = "Önceki ders";
i18n['edu']['reviews'] = "Müşteri yorumları";
i18n['edu']['specialization'] = "Uzmanlık";
i18n['edu']['starts.at'] = "başlangıç saati";
i18n['edu']['themes'] = "Tüm konular";
i18n['edu']['user.certificate'] = function(params) { return params["lastname"] + " kullanıcısının sertifikası" };
i18n['edu']['workFormat'] = "Çalışma formatı";
i18n['solutions'] = {};
i18n['solutions']['analytics'] = "";
i18n['solutions']['cases'] = "Örnek durumlar";
i18n['solutions']['changes'] = "";
i18n['solutions']['city'] = "Şehir";
i18n['solutions']['clear'] = "Temizle";
i18n['solutions']['companySize'] = "Kurum büyüklüğü";
i18n['solutions']['error'] = "Çözümler yüklenemedi. Lütfen, daha sonra deneyin.";
i18n['solutions']['industries'] = "Sektörler";
i18n['solutions']['periods'] = "";
i18n['solutions']['practicums'] = "";
i18n['solutions']['products'] = "Ürünler";
i18n['solutions']['read.more'] = "Daha fazla bilgi";
i18n['solutions']['registration.year'] = "Kuruluş tarihi";
i18n['solutions']['site'] = "Site";
i18n['solutions']['stories'] = "Başarı hikayeleri";
i18n['solutions']['tasks'] = "Görevler";
i18n['solutions']['yandex.year'] = "Yandex'e katılım";
i18n['pages'] = {};
i18n['pages']['contact.description'] = "Satış ofisleri ve ajanslar";
i18n['pages']['contact.keywords'] = "Satış ofisleri, Destek Ekibi, Ajanslar";
i18n['pages']['contact.title'] = "İletişim Bilgileri — Yandex.Reklam";
i18n['pages']['index.description'] = "";
i18n['pages']['index.keywords'] = "";
i18n['pages']['index.title'] = "Yandex.Reklam: Yandex'te Reklamınız";
i18n['pages']['news.title'] = "Haberler — Yandex.Reklam";
i18n['pages']['order.title'] = "Reklamı yayınla";
i18n['pages']['partners-news.title'] = "Kapalı bölümün haberleri";
i18n['pages']['partners.title'] = "Reklam ajanslar için";
i18n['pages']['requirements.title'] = "Reklam materyalleri için aranan koşullar";
i18n['pages']['subscription.partners.title'] = "Reklam ajanslar için haberlere abone ol";
i18n['pages']['subscription.public.title'] = "Reklam teknolojileri haberlerine abone ol";
i18n['agency'] = {};
i18n['agency']['add-office'] = "";
i18n['agency']['address'] = "Adres";
i18n['agency']['agencies-with-certificates'] = function(params) { return "Sertifikalı ajansları görüntülemek için <a href=\"" + params["agenciesPageUrl"] + "\">tıklayın</a>." };
i18n['agency']['agency-experience'] = "Ajans deneyimi";
i18n['agency']['allagencies'] = "Tüm ajanslar";
i18n['agency']['back-to-edit'] = "";
i18n['agency']['bidder'] = "Yandex Bid Management Partner";
i18n['agency']['budget'] = "";
i18n['agency']['budget-placeholder'] = "";
i18n['agency']['cancel-editing'] = "";
i18n['agency']['card-link'] = "Ayrıntılı bilgi";
i18n['agency']['case'] = "Örnek vaka";
i18n['agency']['certificate_plate'] = "https://avatars.mds.yandex.net/get-adv/121152/2a00000165e8410a65a9bba14ae6c34a1923/orig";
i18n['agency']['certificate_title'] = "Yandex certified agency";
i18n['agency']['certificates'] = "Sertifikalar";
i18n['agency']['certified-yandex-agency'] = "Stratejik Ortaklarımız";
i18n['agency']['city'] = "Şehir";
i18n['agency']['contact-info'] = "İletişim bilgileri";
i18n['agency']['description-placeholder'] = "";
i18n['agency']['edit'] = "";
i18n['agency']['editing-mode'] = "";
i18n['agency']['email'] = "E-posta";
i18n['agency']['feedback'] = "İletişime geç";
i18n['agency']['form.button'] = "Gönder";
i18n['agency']['form.email'] = "E-posta adresiniz";
i18n['agency']['form.message'] = "İleti";
i18n['agency']['form.name'] = "Adınız";
i18n['agency']['full-description-counter'] = "";
i18n['agency']['material-error'] = "";
i18n['agency']['material-placeholder'] = "";
i18n['agency']['materials'] = "Ajans materyalleri";
i18n['agency']['modal.title'] = "Ajans ile iletişime geç";
i18n['agency']['name-placeholder'] = "";
i18n['agency']['next'] = "Sonraki";
i18n['agency']['non-active-agency'] = "Bu ajansın şu anda aktif sertifikası yok.";
i18n['agency']['on-moderation'] = "";
i18n['agency']['phone'] = "Telefon";
i18n['agency']['prev'] = "Önceki";
i18n['agency']['preview-description-counter'] = "";
i18n['agency']['qualified-yandex-partner'] = "Stratejik Ortaklarımız";
i18n['agency']['readmore'] = "Ayrıntılı bilgi";
i18n['agency']['remove'] = "";
i18n['agency']['send-to-moderation'] = "";
i18n['agency']['sending-fail'] = "";
i18n['agency']['show-phone'] = "Numarayı göster";
i18n['agency']['show-preview'] = "";
i18n['agency']['site'] = "Web sitesi";
i18n['agency']['specialization'] = "İhtisas";
i18n['agency']['type.appmetrica'] = "Mobile ads";
i18n['agency']['type.bidder'] = "Yandex Direct Bid Management Partner";
i18n['agency']['type.dialogs'] = "Yandex Diyaloglar";
i18n['agency']['type.direct'] = "Direct";
i18n['agency']['type.geomapadv'] = "Yandex Business";
i18n['agency']['type.geonaviadv'] = "Navigator";
i18n['agency']['type.market'] = "Yandex Market";
i18n['agency']['type.media-adv'] = "";
i18n['agency']['type.metrika'] = "Metrica";
i18n['agency']['type.promopages'] = "";
i18n['agency']['type.retargeting'] = "Ecomm+";
i18n['agency']['type.toloka'] = "Yandex Toloka";
i18n['agency']['type.zen'] = "";
i18n['agency']['yandex-partner'] = "Yandex Partner";
i18n['agency']['yandex-leading-partner'] = "Yandex Leading Partner";
i18n['search'] = {};
i18n['search']['0'] = "Haberler";
i18n['search']['1'] = "Arama bazlı reklam";
i18n['search']['2'] = "Medya reklamı";
i18n['search']['3'] = "Mobil reklam";
i18n['search']['4'] = "Küçük reklam ilanları";
i18n['search']['5'] = "Coğrafi reklam";
i18n['search']['6'] = "Örnekler ve başarı hikayeleri";
i18n['search']['7'] = "Eğitim";
i18n['search']['8'] = "Kişiler";
i18n['search']['9'] = "Reklam materyalleri için aranan koşullar";
i18n['search']['all.pages'] = "Tüm sayfalar";
i18n['search']['find'] = "Bul";
i18n['search']['found'] = "Sorguya göre arama";
i18n['search']['materials'] = "Malzemeler";
i18n['search']['not.found'] = "Sorgunuza uygun sonuç bulunamadı.";
i18n['search']['partners'] = "İş ortakları";
i18n['search']['search'] = "Web";
i18n['search']['site.search'] = "Site içi arama";
i18n['search']['switch.left'] = "← + Alt";
i18n['search']['switch.right'] = "Alt + →";
i18n['header'] = {};
i18n['header']['service.adv'] = "Reklam verme teknolojisi";
i18n['header']['service.blog'] = "Blog";
i18n['header']['service.company'] = "ŞİRKET";
i18n['header']['service.edu'] = "";
i18n['header']['service.events'] = "";
i18n['header']['service.science'] = "Bilim";
i18n['header']['service.tech'] = "Teknoloji";
i18n['header']['service.vacancies'] = "Kariyer";
i18n['products'] = {};
i18n['products']['link'] = "Tüm fiyatlar";
i18n['products']['more'] = "Daha fazla göster";
i18n['products']['more-detailed'] = "";
i18n['products']['more.button'] = "Ayrıntılı bilgi";
i18n['products']['order.button'] = "Reklamı sipariş et";
i18n['products']['targetings'] = "Hedefleme türleri:";
i18n['products']['terms'] = "Ürüne göre tüm koşullar";
i18n['months'] = {};
i18n['months']['g1'] = "Ocak";
i18n['months']['g10'] = "Ekim";
i18n['months']['g11'] = "Kasım";
i18n['months']['g12'] = "Aralık";
i18n['months']['g2'] = "Şubat";
i18n['months']['g3'] = "Mart";
i18n['months']['g4'] = "Nisan";
i18n['months']['g5'] = "Mayıs ";
i18n['months']['g6'] = "Haziran";
i18n['months']['g7'] = "Temmuz ";
i18n['months']['g8'] = "Ağustos";
i18n['months']['g9'] = "Eylül";
i18n['months']['n1'] = "Ocak";
i18n['months']['n10'] = "Ekim";
i18n['months']['n11'] = "Kasım";
i18n['months']['n12'] = "Aralık";
i18n['months']['n2'] = "Şubat";
i18n['months']['n3'] = "Mart";
i18n['months']['n4'] = "Nisan";
i18n['months']['n5'] = "Mayıs";
i18n['months']['n6'] = "Haziran";
i18n['months']['n7'] = "Temmuz";
i18n['months']['n8'] = "Ağustos ";
i18n['months']['n9'] = "Eylül";
i18n['file-upload'] = {};
i18n['file-upload']['files-limit-error'] = function(params) { return "En fazla " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "dosya", "some": "dosya", "many": "dosya", "none": "dosya"}) + " eklenebilir" };
i18n['file-upload']['limit-hint'] = function(params) { return "Maksimum " + dynamic.toggle({"condition": params["multiple"], "true": "toplam", "false": ""}) + " boyutu " + params["size"] + " MB olan toplam " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "dosya", "some": "dosya", "many": "dosya", "none": "dosya"}) };
i18n['file-upload']['size-limit-error'] = function(params) { return "Yüklenen dosyaların toplam boyutu " + params["size"] + " MB'ın üzerindedir" };
i18n['file-upload']['upload-text'] = "Yükle";
i18n['sections'] = {};
i18n['sections']['analytics'] = "Analiz";
i18n['sections']['contact'] = "İletişim bilgileri";
i18n['sections']['distribution'] = "Dağıtım";
i18n['sections']['edu.events'] = "Ziyaret önerilerimiz";
i18n['sections']['edu.experts'] = "Eğitim iş ortakları";
i18n['sections']['education'] = "Eğitim";
i18n['sections']['index'] = "Ana sayfa";
i18n['sections']['monetization'] = "Parasallaşma";
i18n['sections']['news'] = "Yandex'te reklam haberleri";
i18n['sections']['order'] = "Reklamı yayınla";
i18n['sections']['partners'] = "Reklam ajanslar için";
i18n['sections']['publishers'] = "Yayıncılar için";
i18n['sections']['requirements'] = "Reklam materyalleri için aranan koşullar";
i18n['sections']['subscription.partners'] = "Reklam ajansları için haberlere abone ol";
i18n['sections']['subscription.public'] = "Reklam teknolojileri haberlerine abone ol";
i18n['sections']['subscription.publishers'] = "";
i18n['sections']['subscription.subs'] = "Reklam teknolojileri haberlerine abone ol";
i18n['menu'] = {};
i18n['menu']['agency'] = "Bölgenizdeki ajanslar";
i18n['menu']['backward'] = "Geri";
i18n['menu']['backward-section'] = "";
i18n['menu']['menu'] = "Menü";
i18n['menu']['offices'] = "Satış ofisleri";
i18n['menu']['order'] = "Reklamı sipariş et";
i18n['menu']['support'] = "Destek Ekibi";
i18n['support'] = {};
i18n['support']['feedback.form'] = "E-posta gönder";
i18n['support']['feedback.link'] = "İletişim Formu";
i18n['materials'] = {};
i18n['materials']['error'] = "";
i18n['partners'] = {};
i18n['partners']['button.back'] = "Geri";
i18n['partners']['button.next'] = "İleri";
i18n['partners']['button.send'] = "Gönder";
i18n['partners']['followTheNews'] = "Haberlerimizi takip edin";
i18n['partners']['form.direct'] = "Yandex.Direct";
i18n['partners']['form.directAndMarket'] = "Yandex.Direct + Yandex.Market";
i18n['partners']['form.disk.button'] = "Beslemeyi Yandex.Disk'e yükle";
i18n['partners']['form.disk.modal.1'] = "<a href=\"https://disk.yandex.ru\" target=\"_blank\">Yandex.Disk'e</a> girip \"Yükle\" butonuna tıklayın. Açılan pencerede beslemenizi seçin.";
i18n['partners']['form.disk.modal.2'] = "Dosya yüklendikten sonra \"Aç\" üzerine tıklayın; dosyanız için bağlantı oluşturulacaktır. Bu bağlantıyı kopyalayın ve form penceresine yapıştırın.";
i18n['partners']['form.disk.pseudolink'] = "Dosyalar Yandex.Disk'e nasıl aktarılır";
i18n['partners']['form.emptyValue'] = "–";
i18n['partners']['form.error.email'] = "E-posta adresi yanlış";
i18n['partners']['form.error.required'] = "Bu alanın doldurulması zorunludur";
i18n['partners']['form.market'] = "Yandex.Market";
i18n['partners']['form.tip'] = "Tüm alanların doldurulması zorunludur";
i18n['partners']['form.ty.contract'] = "Teşekkürler!\nTalebinizi işleyeceğiz ve 2 iş günü içerisinde sizinle irtibat kuracağız.";
i18n['partners']['form.ty.login'] = "Teşekkürler!\nTalebinizi işleyeceğiz ve 2 iş günü içerisinde sizinle irtibat kuracağız.";
i18n['partners']['form.ty.title'] = "Teşekkürler, talebiniz gönderildi!";
i18n['partners']['goal.chooseGoal'] = "Hedef seç";
i18n['partners']['goal.chooseGoal.text'] = "Sözleşme yapmak için minimum koşulları yerine getirmeniz gerekmektedir. Ayrıntılı bilgiyi <a href=\"/adv/partners\">bu bağlantıda</a> bulabilirsiniz";
i18n['partners']['goal.contract'] = "Kullanıcı adım var, sözleşme yapmak istiyorum";
i18n['partners']['goal.contract.text'] = "Talebinizi göndermeden önce tüm müşterilerinizin bulundukları ajansın kullanıcı adıyla sisteme girmeniz gerekmektedir. Böyle bir kullanıcı adınız yoksa \"hem kullanıcı adını hem de sözleşmeyi istiyorum\" hedefini seçmelisiniz.";
i18n['partners']['goal.login'] = "Arayüze erişmek için ajans kullanıcı adı istiyorum";
i18n['partners']['goal.login.direct.text'] = "Direct'in ajans arayüzü ajansların ihtiyaçlarına göre özel olarak geliştirilmiştir. Arayüzün yapısı tüm müşterilerinizi tek bir yerde tutmanızı sağlarken, yöneticileriniz ise sadece gerekli kullanıcı adlarıyla çalışabilir. Arayüze erişim yetkisini almak için minimum koşul şartı yoktur, ajans olmak yeterlidir. Talebinizi gönderin; iki iş günü içerisinde sizinle irtibat kuracağız.";
i18n['partners']['goal.login.directAndMarket.text'] = "Ajans arayüzü özellikle reklam ajanslarının ihtiyaçlarına göre geliştirilmiştir. Burada ajansın tüm müşterilerinin yanı sıra hem Direct'teki hem Market'teki reklamlar yönetilebilir. Ayrıca, her yönetici sadece kendisini ilgilendiren kullanıcılarla çalışabilir.\nArayüze erişmek için özel koşullar gerekmeyip, ajans olmak yeterlidir. Talebinizi gönderin, iki iş günü içerisinde sizinle irtibata geçeceğiz.";
i18n['partners']['goal.login.market.text'] = "Yandex.Market'in ajans arayüzü sayesinde reklam ajansları tüm müşterilerinin reklamlarını tek bir yerden yönetebilir. Ayrıca, her yönetici sadece kendisini ilgilendiren kullanıcılarla çalışabilir. \nArayüze erişmek için özel koşullar gerekmeyip, ajans olmak yeterlidir. Talebinizi gönderin, iki iş günü içerisinde sizinle irtibata geçeceğiz.";
i18n['partners']['menu.becomePartner'] = "İş ortağı olmak";
i18n['partners']['products'] = "Başka hangi Yandex ürünleri müşterilerinizin ilgisini çekebilir:";
i18n['partners']['step1'] = "Adım 1. Genel bilgi";
i18n['partners']['step2'] = "Adım 2. Ajans hedefleri";
i18n['forms'] = {};
i18n['forms']['400_SMF'] = "Abonelik işlemi tamamlanamadı";
i18n['forms']['400_SNA'] = function(params) { return params["param"] + " için abonelik işlemi tamamlanamadı" };
i18n['forms']['400_SNS'] = "Lütfen en az bir abonelik belirtin";
i18n['forms']['403_CCI'] = "girilen kod yanlış";
i18n['forms']['403_ICT'] = "Hata oluştu. Lütfen daha sonra deneyin.";
i18n['forms']['503_MNS'] = "İleti gönderilemedi. Lütfen tekrar yazmayı deneyin.";
i18n['forms']['captcha'] = "Görseldeki kodu girin:";
i18n['forms']['captcha.change'] = "Görseli yenile";
i18n['forms']['emptyValue'] = "–";
i18n['forms']['error'] = "Hata oluştu. Lütfen daha sonra deneyin.";
i18n['forms']['error.server'] = "Hata oluştu. Lütfen daha sonra deneyin.";
i18n['forms']['form'] = "İletişim Formu";
i18n['forms']['label.comment'] = "Yorum";
i18n['forms']['label.email'] = "E-posta adresiniz";
i18n['forms']['label.login'] = "Yandex'teki kullanıcı adınız";
i18n['forms']['label.name'] = "Adınız";
i18n['forms']['label.phone'] = "Telefon";
i18n['forms']['label.region'] = "Bölge";
i18n['forms']['label.site'] = "Web sitesi";
i18n['forms']['subscribed.multi.text'] = "E-posta hesabınızı kontrol edin. Birkaç konu için abone olduysanız her konu için aboneliği ayrı ayrı onaylamanız gerekecek.";
i18n['forms']['subscribed.multi.title'] = "Teşekkürler!";
i18n['forms']['subscribed.single.text'] = "E-posta hesabınızı kontrol edin.";
i18n['forms']['subscribed.single.title'] = "Teşekkürler!";
i18n['forms']['subscription.button'] = "Abone ol";
i18n['forms']['subscription.button.register'] = "Kaydol";
i18n['forms']['success.agency.text'] = "İletiniz ajansa gönderildi.";
i18n['forms']['success.agency.title'] = "Teşekkürler!";
i18n['forms']['success.def.text'] = "Lütfen talebinizi tekrar göndermeyin. Uzmanlarımız en kısa sürede size geri dönüş yapacaklardır.";
i18n['forms']['success.def.title'] = "İletiniz gönderildi";
i18n['filters'] = {};
i18n['filters']['clear'] = "Filtreleri Temizle";
i18n['order'] = {};
i18n['order']['agency'] = "Reklam ajansın aracılığıyla";
i18n['order']['chooseAgency'] = "Ajans seç";
i18n['order']['city'] = "şehir";
i18n['order']['country'] = "Ülke";
i18n['order']['createAd'] = "Reklam oluştur";
i18n['order']['form'] = "Yandex özel yöneticisi yardımıyla";
i18n['order']['personally'] = "Kendi başıma";
i18n['order']['pleaseSpecifyYourLocation'] = "Lütfen konumunuzu belirtin:";
i18n['order']['sendForm'] = "Gönder";
i18n['order']['title'] = "Reklamı yayınla";
i18n['common'] = {};
i18n['common']['addUser'] = "Kullanıcı adını değiştir";
i18n['common']['amp-breadcrumb'] = "Haberler";
i18n['common']['and'] = "ve";
i18n['common']['comdi.not-supported'] = "Kullandığınız tarayıcı sürümü yayını desteklemiyor. <a href=\"https://browser.yandex.ru\" target=\"_blank\">Yandex Browser'ı</a> deneyin";
i18n['common']['conditions'] = "Koşullar";
i18n['common']['days'] = "";
i18n['common']['facebook'] = "Facebook";
i18n['common']['habrahabr'] = "Habrahabr";
i18n['common']['hours'] = "";
i18n['common']['instagram'] = "İnstagram";
i18n['common']['linkedin'] = "LinkedIn";
i18n['common']['loading-error'] = "Önyükleme hatası";
i18n['common']['login'] = "Giriş yap";
i18n['common']['logout'] = "Çıkış yap";
i18n['common']['media.cases'] = "Örnek durumlar";
i18n['common']['media.courses'] = "Eğitim";
i18n['common']['media.stories'] = "Başarı hikayeleri";
i18n['common']['minutes'] = "";
i18n['common']['more.button.error'] = "Hata oluştu. Lütfen daha sonra deneyin.";
i18n['common']['more.button.text'] = "Daha fazla göster";
i18n['common']['news-is-not-available'] = "Haberler bölümü geçici olarak kullanılamıyor.<br /> Lütfen daha sonra tekrar deneyin.";
i18n['common']['no'] = "Hayır";
i18n['common']['oldbrowser.close'] = "Kapat";
i18n['common']['oldbrowser.download'] = "Tarayıcıyı güncelle";
i18n['common']['oldbrowser.text'] = "Servisin sorunsuz çalışması garanti edilemez";
i18n['common']['online.edu'] = "Çevrimiçi eğitim";
i18n['common']['project.name'] = "Reklam teknolojileri";
i18n['common']['rss'] = "RSS";
i18n['common']['search.all_pages'] = "Tüm sayfalar";
i18n['common']['seconds'] = "";
i18n['common']['show-full'] = "Tamamını oku";
i18n['common']['swipe.slideInfo'] = "/";
i18n['common']['twitter'] = "Twitter";
i18n['common']['vkontakte'] = "VKontakte";
i18n['common']['yes'] = "Evet";
i18n['common']['youtube'] = "YouTube";
i18n['common']['сancel'] = "İptal";

export default i18n;